<script setup lang="ts">
defineProps<{
    companyPub: any
}>()

const { state } = useAppStore()
</script>

<template>
    <section
        v-if="companyPub && companyPub.product_lines"
        class="py-32 bg-chsc-raw-light"
    >
        <UContainer class="text-center">
            <header class="mb-6">
                <h2 class="text-chsc-indigo-500 fs-4xl font-eb-garamond font-medium">
                    {{ useText(state.strings, 'sc_product_lines') }}
                </h2>
            </header>
            <p class="fs-2xl">
                {{ companyPub.product_lines }}
            </p>
        </UContainer>
    </section>
</template>
